import React, { useState, useEffect } from "react";
import ProviderConnectors from "./connectors";
import {
  fetchCompanyConnectors,
  fetchAllConnectorsMetadata,
} from "../../../../../services/staffingService";
import { Link, useLocation, useParams } from "react-router-dom";
import DashboardSidebar from "../../agencyDashboardSidebar";



export default function App() {
  const providerCompanyId = useParams().providerCompanyId;
  const [allAvailableConnectors, setAllAvailableConnectors] = useState([]);
  const [providerCompanyConnectors, setProviderCompanyConnectors] = useState([]);
  const [error, setError] = useState(null);
  const [showSideDrawer, setShowSideDrawer] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        const allConnectorsResponse = await fetchAllConnectorsMetadata();
        const companyConnectorsResponse = await fetchCompanyConnectors();

        setAllAvailableConnectors(allConnectorsResponse.data); // Metadata of all available connectors
        setProviderCompanyConnectors(companyConnectorsResponse.data); // Company-specific connectors
        setError(null);
      } catch (e) {
        console.error("Error fetching data:", e);
        setError(e.message);
      }
    };

    loadData();
  }, []);

  if (error) {
    return <h2>An error occurred: {error}</h2>;
  }

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 font-inter">
      <DashboardSidebar isOpen={showSideDrawer} setIsOpen={setShowSideDrawer} />
      <main className="flex-1 overflow-y-auto">
        <div className="p-6">
          <ProviderConnectors
            allAvailableConnectors={allAvailableConnectors}
            providerCompanyConnectors={providerCompanyConnectors}
            providerCompanyId={providerCompanyId}
          />
        </div>
      </main>
    </div>
  );
}
